module.exports = __webpack_public_path__ + "img/pulse3.4a39788b.jpg";